const RETRY_INTERVAL = 500;

export const fetchWithRetry = async (url, options = {}, retryCount = 0, retryInterval = RETRY_INTERVAL) => {
    let attempt = 0;

    while (attempt <= retryCount) {
        try {
            const response = await fetch(url, options);

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            return response;
        }
        catch (error) {
            attempt++;
            if (attempt > retryCount) {
                return undefined;
            }

            if (attempt <= retryCount) {
                await new Promise(resolve => setTimeout(resolve, retryInterval));
            }
        }
    }
    throw new Error('Unexpected error: Fetch function did not return or throw within retries.');
};
